import { render, staticRenderFns } from "./ModalStatusHistory.vue?vue&type=template&id=5194b912&scoped=true&"
import script from "./ModalStatusHistory.vue?vue&type=script&lang=js&"
export * from "./ModalStatusHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194b912",
  null
  
)

export default component.exports